// src/components/ChatWidget.js - MODIFICADO COM A PONTE DE VARIÁVEIS DE TEMA

import React, { useState, useEffect } from "react";
import styles from "./ChatWidget.module.css";
import ChatBody from "./ChatBody";
import { TbMessageCircleQuestion } from "react-icons/tb";
import { RiArrowDownSLine } from "react-icons/ri";

export default function ChatWidget({ chatflowid, apiHost, enableAudio, enableFeedback, contextVars, theme, headerTitle, initialMessage }) {
  const [open, setOpen] = useState(false);
  
  // A lógica de state e handlers não muda.
  const [messages, setMessages] = useState(() => {
    try {
      const savedMessages = localStorage.getItem('chat_messages');
      if (savedMessages && JSON.parse(savedMessages).length > 0) {
        return JSON.parse(savedMessages);
      }
      return initialMessage ? [{ from: 'bot', text: initialMessage, isComplete: true }] : [];
    } catch (error) {
      console.error("Failed to parse messages from localStorage", error);
      return initialMessage ? [{ from: 'bot', text: initialMessage, isComplete: true }] : [];
    }
  });
  const [inputValue, setInputValue] = useState(() => localStorage.getItem('chat_inputValue') || "");
  const [sessionId, setSessionId] = useState(() => localStorage.getItem('chat_sessionId') || Date.now().toString());
  const [audioData, setAudioData] = useState(null);
  useEffect(() => {
    localStorage.setItem('chat_messages', JSON.stringify(messages));
    localStorage.setItem('chat_inputValue', inputValue);
    localStorage.setItem('chat_sessionId', sessionId);
  }, [messages, inputValue, sessionId]);
  const handleReset = () => {
    localStorage.removeItem('chat_messages');
    localStorage.removeItem('chat_inputValue');
    localStorage.removeItem('chat_sessionId');
    setMessages(initialMessage ? [{ from: 'bot', text: initialMessage, isComplete: true }] : []);
    setInputValue("");
    setSessionId(Date.now().toString());
    setAudioData(null);
  };

  // ==================================================================
  // INÍCIO DA MODIFICAÇÃO: A Ponte de Variáveis CSS
  // ==================================================================
  const configTheme = theme || {}; // Garante que o objeto theme sempre exista

  // Este objeto transforma as props do tema em variáveis CSS
  const themeVars = {
    '--theme-primary': configTheme.primary || '#FF7A01',
    '--theme-accent': configTheme.accent || '#29C06F',
    '--theme-background': configTheme.background || '#222A32',
    '--theme-foreground': configTheme.foreground || '#ffffff',
    '--theme-bot-bubble-background': configTheme.botBubbleBackground || '#ffffff',
    '--theme-bot-bubble-foreground': configTheme.botBubbleForeground || '#222A32',
    '--theme-user-bubble-background': configTheme.userBubbleBackground || '#FF7A01',
    '--theme-user-bubble-foreground': configTheme.userBubbleForeground || '#ffffff',
    '--theme-input-background': configTheme.inputBackground || '#ffffff',
    '--theme-input-foreground': configTheme.inputForeground || '#222A32',
    '--theme-input-placeholder': configTheme.inputPlaceholder || '#717579',
    '--theme-border-color': configTheme.borderColor || '#e3e6e8',
	'--theme-audio-transcription-foreground': configTheme.audioTranscriptionForeground || '#717579',
    '--theme-feedback-like': configTheme.feedbackLike || '#29C06F',
    '--theme-feedback-dislike': configTheme.feedbackDislike || '#E64545',
  };
  // ==================================================================
  // FIM DA MODIFICAÇÃO
  // ==================================================================

  return (
    // A mágica acontece aqui: aplicamos as variáveis CSS ao container principal
    <div className={styles['flowise-chat-widget']} style={themeVars}>
      <div
        className={styles['chat-window-wrapper']}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? "auto" : "none",
          transform: open ? "scale(1) translate(0,0)" : "scale(0.6) translate(0, 60px)",
          transition: "opacity 0.18s cubic-bezier(.4,0,.2,1), transform 0.20s cubic-bezier(.4,0,.2,1)",
          transformOrigin: "bottom right"
        }}
      >
        {open && (
          // O `borderColor` foi removido daqui, pois será controlado pelo CSS agora
          <div className={styles['chat-window']}>
            <ChatBody
              chatflowid={chatflowid} apiHost={apiHost} enableAudio={enableAudio}
              enableFeedback={enableFeedback} contextVars={contextVars} theme={theme}
              onClose={() => setOpen(false)} headerTitle={headerTitle}
              inputValue={inputValue} onInputChange={setInputValue}
              messages={messages} setMessages={setMessages}
              audioData={audioData} setAudioData={setAudioData}
              onReset={handleReset}
            />
          </div>
        )}
      </div>

      <button
        className={`${styles['chat-float-toggle-btn']} ${open ? styles['open'] : ""}`}
        // O `background` foi removido daqui, pois será controlado pelo CSS agora
        onClick={() => setOpen(!open)}
        title={open ? "Fechar chat" : "Abrir chat"}
        aria-label={open ? "Fechar chat" : "Abrir chat"}
      >
        <span className={styles['icon-stack']}>
          <TbMessageCircleQuestion
            className={`${styles['toggle-icon']} ${styles['toggle-icon-chat']}`}
            // A `color` foi removida daqui, pois será controlada pelo CSS agora
          />
          <RiArrowDownSLine
            className={`${styles['toggle-icon']} ${styles['toggle-icon-chevron']}`}
            // A `color` foi removida daqui, pois será controlada pelo CSS agora
          />
        </span>
      </button>
    </div>
  );
}